document.querySelectorAll('.chat__form input').forEach(function (input) {
  console.log(input);
  input.addEventListener('focus', function (evt) {
    document.querySelector('.page__nav').classList.add('hidden');
  });
  input.addEventListener('blur', function (evt) {
    document.querySelector('.page__nav').classList.remove('hidden');
  });
});